module.exports = __webpack_public_path__ + "images/emoji/pencil2.ce9d2647e3d895f0cf4e.png";